export default __webpack_public_path__ + "static/media/nav.6be0e825.svg";